import { logger } from "../util/common";

/**
 * CometChatManager class encapsulates the following functionality:
 * - getting logged in user
 * - blocks a list of users
 * - unblocks a list of users
 * - initiate a call
 * - accept a call
 * - reject a call
 */
export class CometChatManager {
    loggedInUser;
    isUserLoggedIn;

    /**
   * Gets the current logged in user
   */
    async getLoggedInUser() {
        const CometChat = window.CometChat;
        if (!CometChat) {
            throw new Error('CometChat not initialized');
        }

        if (this.loggedInUser) {
            return this.loggedInUser;
        }

        const user = await CometChat.getLoggedinUser();

        if (user) {
            this.loggedInUser = user;
            return user;
        }

        throw new Error('No user logged in');
    }

    /**
   * Blocks a list of users
   * @param {*} userList
   */
    static blockUsers = (userList) => {
        const CometChat = window.CometChat;
        return new Promise((resolve, reject) => {
            CometChat.blockUsers(userList).then(
                (list) => resolve(list),
                (error) => reject(error)
            );
        });
    };

    /**
   * Unblocks a list of users
   * @param {*} userList
   */
    static unblockUsers = (userList) => {
        const CometChat = window.CometChat;
        return new Promise((resolve, reject) => {
            CometChat.unblockUsers(userList).then(
                (list) => resolve(list),
                (error) => reject(error)
            );
        });
    };

    /**
   * Initiates a call
   * @param {*} receiverID
   * @param {*} receiverType
   * @param {*} callType
   */
    static call = (receiverID, receiverType, callType) => {
        return new Promise((resolve, reject) => {
            const call = new CometChat.Call(receiverID, callType, receiverType);
            CometChat.initiateCall(call).then(
                (call) => resolve(call),
                (error) => reject(error)
            );
        });
    };

    /**
   * Initiates an audio call
   * @param {*} receiverID
   * @param {*} receiverType
   * @param {*} callType
   */
    static audioCall = (receiverID, receiverType, callType) => {
        return new Promise((resolve, reject) => {
            const call = new CometChat.Call(receiverID, callType, receiverType);
            CometChat.initiateCall(call).then(
                (call) => resolve(call),
                (error) => reject(error)
            );
        });
    };

    /**
   * Accept a call
   * @param {*} sessionId
   */
    static acceptCall = (sessionId) => {
        return new Promise((resolve, reject) => {
            CometChat.acceptCall(sessionId).then(
                (call) => resolve(call),
                (error) => reject(error)
            );
        });
    };

    /**
   * Reject a call
   * @param {*} sessionId
   * @param {*} rejectStatus
   */
    static rejectCall = (sessionId, rejectStatus) => {
        return new Promise((resolve, reject) => {
            CometChat.rejectCall(sessionId, rejectStatus).then(
                (call) => resolve(call),
                (error) => reject(error)
            );
        });
    };
}

export default CometChatManager;
